import { IonContent, IonPage, IonRow } from "@ionic/react";
import { Redirect } from "react-router";
import TrackingGrid from "../../components/AE2/TrackingSection/TrackingGrid";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import { isStaff } from "../../components/extras/Functions";
import AlphaInsightsHeader from "../../components/AE2/AlphaInsightsHeader";

const Tracking: React.FC = () => {
  const user = useAppSelector(selectUser);

  if (user.first_name !== "" && !isStaff(user)) {
    return <Redirect to="/403" />;
  }

  return (
    <IonPage className="ae2-home">
      <AlphaInsightsHeader/>
      <IonContent className="bg-main">
        <IonRow className="ion-justify-content-center">
          <h1 className="main-heading">Alpha Insights Tracking</h1>
        </IonRow>
        <TrackingGrid />
      </IonContent>
    </IonPage>
  );
};

export default Tracking;
